import React from 'react';
import Post from '../../components/Post';

function GuidedMeditation(props) {
  return (
    <Post {...props} />
  )
}

export default GuidedMeditation;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/GuidedMeditation/index.js